"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Observable_1 = require("rxjs/Observable");
var base_condition_1 = require("./base.condition");
var models_1 = require("../../models");
var TimeSinceLastInviteBySiteCondition = /** @class */ (function (_super) {
    __extends(TimeSinceLastInviteBySiteCondition, _super);
    function TimeSinceLastInviteBySiteCondition(lastInvitationTime, options, notificationService) {
        var _this = _super.call(this, "TimeSinceLastInviteBySiteCondition", notificationService) || this;
        var result = false;
        if (options.hasOwnProperty('Min')) {
            console.log("TimeSinceLastInviteBySite :  Configuration parameter Min is " + options.Min + " Minutes");
            if (lastInvitationTime) {
                var diffFromLastVisit = Date.now() - lastInvitationTime;
                console.log("TimeSinceLastInviteBySite : time of last Invitation By Site is  " + lastInvitationTime + " Millisecond");
                var threshold = options.Min * 60 * 1000;
                result = (diffFromLastVisit >= threshold);
                console.log("TimeSinceLastInviteBySite : difference of time since last Invitation is " + diffFromLastVisit + " Millisecond");
                if (result)
                    console.info("TimeSinceLastInviteBySite condition passed!!");
                else
                    _this.onConditionFail(models_1.ConditionFailReason.CriteriaFail, "TimeSinceLastInviteBySite condition failed!!");
            }
            else {
                console.log("TimeSinceLastInviteBySite :  first invite hence condition is returning true");
                console.info("TimeSinceLastInviteBySite condition passed!!");
                result = true;
            }
        }
        else {
            _this.onConditionFail(models_1.ConditionFailReason.ConfigurationError, "TimeSinceLastInviteBySite :  Configuration error parameter Min missing");
            console.info("TimeSinceLastInviteBySite condition failed!!");
            result = false;
        }
        _this.observable = new Observable_1.Observable(function (observer) {
            observer.next(result);
        });
        return _this;
    }
    return TimeSinceLastInviteBySiteCondition;
}(base_condition_1.BaseCondition));
exports.TimeSinceLastInviteBySiteCondition = TimeSinceLastInviteBySiteCondition;
